type Props = {
  gallery: string[]
  resolvedImage: string
  isDarkMode: boolean
  onSelectImage: (url: string) => void
}

export const ZoomThumbnails = ({ gallery, resolvedImage, isDarkMode, onSelectImage }: Props) => {
  if (gallery.length <= 1) return null

  return (
    <div className="grid grid-cols-5 gap-2 sm:grid-cols-8">
      {gallery.map((url) => (
        <button
          key={url}
          type="button"
          onClick={() => onSelectImage(url)}
          className={`overflow-hidden rounded-lg border ${
            resolvedImage === url
              ? 'border-emerald-400 ring-2 ring-emerald-300/30'
              : isDarkMode
              ? 'border-slate-700'
              : 'border-slate-200'
          }`}
        >
          <img
            src={url}
            alt="Anteprima miniatura"
            loading="lazy"
            decoding="async"
            fetchPriority="low"
            className="h-14 w-full object-cover"
          />
        </button>
      ))}
    </div>
  )
}
